const prefix = 'loginForm';

export const LOGIN = `${prefix}/LOGIN`;
